export const RecentProjectData = [
  
  {
    title: 'Software marketplace',
    detail:
      'Our software marketplace, built with Laravel and Vue.js, features multiple payment gateways and advanced search functionality, providing an intuitive and secure platform for buyers and sellers to conduct transactions with ease.',
    image: process.env.PUBLIC_URL + '/images/software_marketplace.jpg',
    buttons: [{ label: 'Demo', link: 'https://#.com' }, { label: 'Code', link: 'https://github.com/bikashxsharma/hotel-triple-hill' },],
    status: 'Private Repo',
  },
  {
    title: 'Cryptocurrency Exchange Site',
    detail:
      'Our cutting-edge cryptocurrency exchange site, built with Laravel for backend development, Web3 for seamless integration with blockchain technology, advanced security measures to protect user data and transactions, and React for a streamlined frontend experience, provides users with a secure, user-friendly platform to easily buy, sell, and trade cryptocurrencies.',
    image: process.env.PUBLIC_URL + '/images/p2p marketplace site.png',
    buttons: [{ label: 'Demo', link: 'https://#.netlify.app/left' }, { label: 'Code', link: 'https://github.com/bikashxsharma/cv-maker-react' },],
    status: 'Private Repo',
  },
  {
    title: 'My portfolio',
    detail:
      'This is a portfolio showcasing my skills in front-end development with React and TypeScript, including design abilities using Figma, and proficiency in SCSS for creating responsive and cross-browser compatible styles.',
    image: process.env.PUBLIC_URL + '/images/portfolio.png',
    buttons: [{ label: 'Demo', link: 'https://#.netlify.com/' }, { label: 'Code', link: 'https://github.com/cutuphunter/bikash-portfolio' }],
  },
  {
    title: 'Django MVT Ecommerce',
    detail:
      'This ecommerce website is built using the Django web framework and follows the Model-View-Template (MVT) architecture, allowing for efficient data management, separation of concerns, and easy maintainability, with features such as a secure shopping cart, payment gateway integration, order tracking, inventory management, and user authentication.',
    image: process.env.PUBLIC_URL + '/images/django_ecommerce.png',
    buttons: [{ label: 'Demo', link: 'https://#.netlify.app/' }, { label: 'Code', link: 'https://github.com/cutuphunter/vue-lets-do-it' }],
  },
  {
    title: 'Crypto Wallet App',
    detail:
      'Discover our cryptocurrency wallet mobile app made with Flutter and Dart, featuring Web3 integration for secure blockchain transactions and easy payment management',
    image: process.env.PUBLIC_URL + '/images/p2p_marketplace_app.jpg',
    buttons: [{ label: 'Demo', link: 'https://#.netlify.app/' }, { label: 'Code', link: 'https://github.com/cutuphunter/country-api' }],
  },
 
  {
    title: 'WP Woo-Commerce plugin',
    detail:
      'This project involves customizing a Woocommerce plugin for WordPress to improve the user experience, increase customer satisfaction and drive sales by modifying its functionality using programming languages such as PHP and JavaScrip',
    image: process.env.PUBLIC_URL + '/images/woo-commerce.png',
    buttons: [{ label: 'Demo', link: 'https://#.netlify.app/' }, { label: 'Code', link: "https://github.com/bikashxsharma/weekly-trending" }],
  },

]
